export default __webpack_public_path__ + "static/media/alexander3big_thumb.1b4bc750.jpg";